// extracted by mini-css-extract-plugin
export default {"handle":"StaffReorderPanel_handle__szqsB"};